import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53955c71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-layout" }
const _hoisted_2 = { class: "left-block" }
const _hoisted_3 = { class: "p-3 flex items-center" }
const _hoisted_4 = { class: "right-block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-header" }, null, -1))
const _hoisted_6 = { class: "app-body" }

import NavigationMenu from '@components/navigation/NavigationMenu';
import LangSelect from '@components/lang-select/LangSelect.vue';
import { useNavigationNodes } from './navigation-nodes';
import { initDictionary } from '../../stores/helpers/init-dictionary';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

initDictionary();
const { navigationNodes } = useNavigationNodes();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NavigationMenu), { nodes: _unref(navigationNodes) }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(LangSelect, { class: "flex-grow" })
          ])
        ]),
        _: 1
      }, 8, ["nodes"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})